<soph-header-sophia />

<div class="header-container">
  <h1>Mis Pacientes</h1>
  <div class="back-link">
    <mat-icon>arrow_back</mat-icon>
    <a href="/calendario">Volver a Tu Agenda</a>
  </div>
</div>

<div class="container-patient">

  <div>
    <h3 style="padding-left: 50px">Paciente</h3>
    <section class="history-360__header">
      <div class="history-360__header--div1">
        <img src="../../../../assets/icons/Avatar.svg" height="53" width="53"/>
        <div>
          <p>Nombre: <span>{{ care().completeName }}</span></p>
          <p>Historia clínica: <span>{{ care().historiaClinica || '' }}</span></p>
        </div>
      </div>
      <div class="history-360__header--div2">
        <img
          src="../../../../assets/icons/Calendar.svg"
          height="20"
          width="20"
          alt="Logo"
          style="    padding-top: 4px;"
        />
        <label style="margin-left: 8px;">
          Última fecha de atención:
          <span>{{ care().date | date:'dd/MM/yyyy' }}</span>
        </label>
        @if ( care().type ) {
          <div class="chip-tipo-consulta"
               [class.presencial]="care().type.toLocaleLowerCase() === 'presencial'"
               [class.telemedicina]="care().type.toLocaleLowerCase() === 'telemedicina'"
               [class.domiciliaria]="care().type.toLocaleLowerCase() === 'domiciliaria'"
          >
            @switch ( care().type.toLocaleLowerCase()) {
              @case ('presencial') {
                <div>
                  <img src="assets/icons/hospital.svg" style="display: table-cell" alt="hospital"/>
                </div>
              }
              @case ('telemedicina') {
                <div>
                  <img src="assets/icons/telemedicina.svg" style="display: table-cell" alt="telemedicina"/>
                </div>
              }
              @case ('domiciliaria') {
                <div>
                  <img src="assets/icons/house.svg" style="display: table-cell" alt="house"/>
                </div>
              }
            }
            <p class="style-texto-chip" style="margin-bottom: 0">
              {{ capitalizeType( care().type ) }}
            </p>
          </div>
        }
      </div>
    </section>

    <section class="history-360__bread">
      <div class="history-360__bread--blue">
        <label>Historial de consultas ( {{ total() }} )</label>
      </div>
    </section>

    <section class="history-360__header">
      <div class="history-360__header--div1">
        @if ( hasHistory360() ) {
          <button (click)="openHistory360()" class="history-360-btn">
            <img ngSrc="assets/images/Logo-mini.svg" alt="" height="17" width="17" />
            <span> Ver Historial 360&deg; </span>
          </button>
        }
      </div>
      <div class="history-360__header--div2">

      </div>
    </section>
  </div>

  <soph-tabla-atenciones
    [careList]="history()"
    [isMenuOpen]="isMenuOpen()"
    (mustShowDocumentsMenu)="hasToShowMenu( $event )"
  />

  <soph-pager [currentPage]="page()" [pageSize]="pageSize()" [totalElements]="total()" (onUpdatePage)="onUpdatedPage( $event )" />

  @if ( actions() && position() ) {
    <div
      class="dropdown-menu"
      [style.top]="position()!.top + 'px'"
      [style.left]="position()!.left + 'px'"
      (clickOutside)="hasToShowMenu()"
    >
      @for ( doc of actions(); track $index) {
        <div
          class="dropdown-item"
          (click)="doc.action(); hasToShowMenu()"
        >
          <mat-icon svgIcon="custom-eye-open" class="tp-icon-sm"></mat-icon>
          <span class="item-label">{{ doc.label }}</span>
        </div>
      } @empty {
        <div class="dropdown-item disabled">
          <span class="item-icon">ℹ️</span>
          <span class="item-label">No hay documentos</span>
        </div>
      }
    </div>
  }

</div>
